<template>
    <div class="strategy-backtest">
       <label>
            <input type="text" v-model="strategyKeyWord" placeholder="搜索关键词" @keyup.enter="updateSearchStrategy">
            <span @click="updateSearchStrategy"></span>
        </label>
        <div class="list">
            <p v-show="isSearchResult && !isFromSearch">
                <span>你还没有创建任何策略哦~</span><br>
                <router-link :to="'/strategybacktest'">
                        <span class="created">立即创建我的策略</span>
                </router-link>
            </p>
            <p v-show="isSearchResult && isFromSearch">暂无查询列表数据</p>
            <vue-loading v-show="isshowloading" style="height: calc(100% - 20px);border:none;top:0;left:0"></vue-loading>
            <strategy-row-item v-show="!isSearchResult && !isshowloading" v-for="(item, index) in strategyDataList" :key="index"
                :index-serial="index"
                :page="currentPage"
                :strategy-id="item.property.id"
                :buy-position="parseInt(item.property.buyPosition)"
                :strategy-type="item.property.type"
                :strategy-name="item.property.name"
                :strategy-logic="item.property.logic"
                :strategy-ctime="item.property.ctime"
                :strategy-annual-yield="item.property.annualYield"
                :strategy-win-rate="item.property.winRate"
                :strategy-tags="item.property.tags"
                :strategy-user="item.author.userName"
                :strategy-avatar="item.author.avatar"
                :strategy-user-id="item.author.userId"
                :strategy-collect-num="item.interaction.collectNum"
                :strategy-comment-num="item.interaction.commentNum"
                :strategy-is-collected="item.interaction.isCollected"
                :strategy-is-subscribe="item.interaction.isSubscribe"
                :strategy-is-publish="item.interaction.isPublish"
                @subscribe="subscribe"
                @cancel-subscribe="cancelSubscribe"
                @delete-strategy="deleteStrategy">
            </strategy-row-item>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    import strategyRowItem from './strategy-row-item'
    export default {
        name: 'strategy-backtest',
        components: {
            strategyRowItem
        },
        created () {
            this.updateList()
        },
        data () {
            return {
                strategyKeyWord: '',
                isSearchResult: false,
                isFromSearch: true,
                isshowloading: false,
                pageSize: 10,
                currentPage: 1,
                sortSelect: ''
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.myStrategy.createdStrategy
            },
            tradeBacktestData () {
                return this.$store.getters['myStrategy/tradeBacktestData']
            },
            strategyDataList () {
                return this.tradeBacktestData.list
            },
            total () {
                return this.tradeBacktestData.num
            }
        },
        methods: {
            updateSearchStrategy () {
                window.TA.log(this.buriedPoint.search)
                this.updateList()
            },
            deleteStrategy () {
                this.updateList()
            },
            subscribe () {
                this.updateList()
            },
            cancelSubscribe () {
                this.updateList()
            },
            goPage (page) {
                window.TA.log(this.buriedPoint.strategyBacktestPage)
                this.currentPage = page
            },
            updateList () {
                var self = this
                this.isSearchResult = false
                this.isshowloading = true
                this.$store.dispatch('myStrategy/requestTradeBacktest', {
                    page: this.currentPage,
                    pageNum: this.pageSize,
                    sortType: this.sortSelect,
                    keyword: this.strategyKeyWord
                }).then((result) => {
                    if (self.strategyDataList.length === 0) {
                        this.isFromSearch = Boolean(this.strategyKeyWord)
                        this.isSearchResult = true
                    }
                    this.isshowloading = false
                }).catch((error) => {
                    self.isshowloading = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/strategy-backtest.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/strategy-backtest.vue